// extracted by mini-css-extract-plugin
export default {"items":"attachments-menu_items__ci6aP","item":"attachments-menu_item__3xIuo","input":"attachments-menu_input__h1Ipv"};